export const getChildCampaignTitleFromParent = (parentCampaign: {
  title: string;
}) => {
  const titleRegex = /(.*?)(#(\d+)?)?$/; // Capture title and optional #n
  const match = parentCampaign.title.match(titleRegex);

  if (!match) return `${parentCampaign.title} #1`; // Fallback case

  const baseTitle = match[1].trim();
  const currentNumber =
    match[3] && match[3] !== '' ? parseInt(match[3], 10) : 0;
  const newNumber = currentNumber ? currentNumber + 1 : 1;

  return `${baseTitle} #${newNumber}`.trim();
};
